var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconsLoadingMore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "33px",
    height: "24px",
    viewBox: "0 0 33 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icons / large / loading") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "loading-/-large",
    transform: "translate(0.000000, -29.000000)",
    stroke: "#1A1919",
    strokeWidth: 1.81818182
  }, /*#__PURE__*/React.createElement("g", {
    id: "loading",
    transform: "translate(0.000000, 7.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 18.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-loading",
    transform: "translate(0.000000, 5.035028)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(14.714101, 7.309981)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13,1.61996251 C5.82029825,1.61996251 0,7.44026076 0,14.6199625",
    id: "Oval",
    transform: "translate(6.500000, 8.119963) rotate(-180.000000) translate(-6.500000, -8.119963) "
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-4",
    transform: "translate(12.518592, 3.222191) rotate(-350.000000) translate(-12.518592, -3.222191) ",
    points: "7.82739384 5.66690459 12.722118 0.777477247 17.2097894 5.02973135"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(8.781520, 7.309981) rotate(-180.000000) translate(-8.781520, -7.309981) "
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13,1.61996251 C5.82029825,1.61996251 0,7.44026076 0,14.6199625",
    id: "Oval",
    transform: "translate(6.500000, 8.119963) rotate(-180.000000) translate(-6.500000, -8.119963) "
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-4",
    transform: "translate(12.518592, 3.222191) rotate(-350.000000) translate(-12.518592, -3.222191) ",
    points: "7.82739384 5.66690459 12.722118 0.777477247 17.2097894 5.02973135"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsLoadingMore);
export default __webpack_public_path__ + "static/media/icons_loading-more.c74836ca.svg";
export { ForwardRef as ReactComponent };